import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';
import { Button } from '@components/ui/button';
import { PhoneSentProps } from './types';

export const PhoneSent = ({
  people,
  foreman,
  date,
  time,
  confirmed,
  onBack,
  onEdit,
}: PhoneSentProps) => {
  const { t } = useTranslation('app', { keyPrefix: 'scheduling.phone.sent' });
  const rows = [
    [t('date'), date],
    [t('time'), time],
    [t('status'), t(confirmed ? 'confirmed' : 'notConfirmed')],
  ];

  return (
    <div className="absolute inset-0 z-[65] flex flex-col gap-4 bg-white px-4 pb-[calc(24px+env(safe-area-inset-bottom,0px))] pt-20">
      <span className="flex h-14 w-14 items-center justify-center rounded-full border border-primary-100 bg-primary-50">
        <Check className="h-7 w-7 text-primary-500" strokeWidth={2.6} />
      </span>
      <div className="flex flex-col gap-1">
        <h2 className="text-[22px] font-bold text-neutral-800">{t('title')}</h2>
        <p className="text-sm text-neutral-500">
          {[t('to', { count: people }), foreman && t('foreman', { name: foreman })]
            .filter(Boolean)
            .join(' · ')}
        </p>
      </div>
      <dl className="flex flex-col rounded-lg border border-neutral-200">
        {rows.map(([label, value]) => (
          <div
            key={label}
            className="flex justify-between gap-2.5 border-b border-neutral-100 px-3 py-2.5 text-sm last:border-b-0">
            <dt className="text-neutral-500">{label}</dt>
            <dd className="text-right font-semibold text-neutral-800">{value}</dd>
          </div>
        ))}
      </dl>
      <div className="flex-1" />
      <Button className="h-11 justify-center" onClick={onBack}>
        {t('back')}
      </Button>
      <Button variant="secondary" className="h-11 justify-center" onClick={onEdit}>
        {t('edit')}
      </Button>
    </div>
  );
};
